export const MOCK_DRIVER_TAGS = [
    { emoji: '👍', label: 'Easy to find', count: 42 },
    { emoji: '🧹', label: 'Clean', count: 38 },
    { emoji: '🔒', label: 'Safe', count: 35 },
    { emoji: '💡', label: 'Well lit', count: 29 },
    { emoji: '🅿️', label: 'Easy parking', count: 26 },
];
